const paths = {
	accountDetails: '/account',
	accountPreferences: '/account/preferences',
	accountUsers: '/account/users',
	accountActivity: '/account/activity',
	billingOverview: '/account/billing',
	billingTransactions: '/account/billing/transactions',
	cloudVpn: '/account/cloud-vpn',
	secureNotes: '/account/secure-notes',
	apiTokens: '/account/api-tokens',
	sshKeys: '/account/ssh-keys',
	compliance: '/account/compliance',
} as const;

export default paths;
